import { CarrierPickupAvailabilityOptions } from './CarrierPickupAvailabilityOptions';
import { ParcelSchedulingError } from './ParcelSchedulingError';

export class ApiParcelPickupAvailabilityDetails {
  errors: ParcelSchedulingError[] = [];
  availabilityOptions: CarrierPickupAvailabilityOptions[] = [];

  constructor(opts?: Partial<ApiParcelPickupAvailabilityDetails>) {
    if (opts?.errors != null) {
      this.errors = opts.errors.map((val) => new ParcelSchedulingError(val));
    }
    if (opts?.availabilityOptions != null) {
      this.availabilityOptions = opts.availabilityOptions.map(
        (val) => new CarrierPickupAvailabilityOptions(val),
      );
    }
  }
}
